var lodash = require('lodash');
const { sendToNative } = require('../services/reactNativeBridge.js');

const messageType = "utils";

const isConnectedToInternet = () => {
    return sendToNative({
        type: messageType,
        action: "isConnectedToInternet",
    });
};



const generateUniqueStringBasedOnTimestamp = (prefix) => {
    let out = new Date().getTime() * Math.random() * 100000;
    return ((prefix || '') + out + 'cp');
}


const getComponentID = (id) => {
    if (id) { return id }
    return generateUniqueStringBasedOnTimestamp('clic');
}


const getComponentIDForTableBasedOnIndex = (row, prefix = "") => {
    const item = lodash.get(row, 'item', {});
    const itemId = item._id || item.id || item.codigo;
    const fieldId = lodash.get(row, 'field.id');
  
    if (itemId && fieldId) {
      return `${prefix}_${itemId}_${fieldId}`;
    }
  
    return generateUniqueStringBasedOnTimestamp('clic');
  };
  

const getComponentIDMixin = ({cpId, stateKey}) => {
    if(stateKey && cpId){
        return `mixin_id_${stateKey}_${cpId}`;
    }else if(stateKey){
        return `mixin_id_${stateKey}`;
    }else if(cpId){
        return `mixin_id_${cpId}`;
    }
    
    return generateUniqueStringBasedOnTimestamp('clic');
}

module.exports = {
    generateUniqueStringBasedOnTimestamp,
    getComponentID,
    getComponentIDForTableBasedOnIndex,
    getComponentIDMixin,
    isConnectedToInternet
}

